import * as MessagesQueueSelectors                                  from './selectors';
import { sendMessage, uploadFile, waitUntilFileFinishesProcessing } from '../contacts/actions';

// When a message fails, we are going to set the status as 'inQueueError'
// to that message and the next messages that were sent within 10 seconds
// this function returns the IDs of those messages
function getMessagesIdsWithinMs(customerQueue, messageId, ms = 10000) {
  const messageIndex = customerQueue.findIndex(message => message.id === messageId);

  return customerQueue.reduce((acc, message) => {
    const messageTimestamp      = new Date(message.timestamp).getTime();
    const messageErrorTimestamp = new Date(customerQueue[messageIndex].timestamp).getTime();

    if ((messageTimestamp - messageErrorTimestamp) < ms)
      acc.push(message.id);
    return acc;
  }, []);
}

function updateFileProgress({ progress, customerID, dispatch, message }) {
  const attachment    = message.attachments[0];
  attachment.progress = progress;

  const messageAttachmentWithProgress = {
    ...message,
    attachments: [ attachment ]
  };

  dispatch({
    type:    'UPDATE_MESSAGE',
    payload: { message: messageAttachmentWithProgress, customerID }
  });
}

function processQueue(customerID) {
  return async function(dispatch, getState) {
    const customerQueue = MessagesQueueSelectors.getContactMessagesQueue(getState(), customerID);
    const message       = customerQueue.find(msg => msg.status === 'inQueuePending');

    if (message) {
      if (!MessagesQueueSelectors.isQueueRunning(getState(), customerID))
        dispatch({ type: 'QUEUE_IS_RUNNING', payload: { customerID } });

      try {
        if (message.attachments && !message.files) {
          const attachment = message.attachments[0];
          const businessID = message.businessID;

          const { fileID, mimeType } = await uploadFile({
            businessID,
            clientID:   message.id,
            dispatch,
            fileEntry:  attachment,
            position:   0,
            onProgress: progress => updateFileProgress({ progress, customerID, dispatch, message }),
            getState
          });
          // eslint-disable-next-line require-atomic-updates
          message.files = [{ id: fileID, mimeType }];

          // Save nativeURL of the file so we can still show the image
          // while the server is processing it
          dispatch({
            type:    'ADD_LOCAL_FILE',
            payload: { fileID, nativeURL: attachment.nativeURL }
          });

          await waitUntilFileFinishesProcessing({ businessID, dispatch, fileID });
        }

        await dispatch(sendMessage(message));
        dispatch({
          type:    'REMOVE_MESSAGE_FROM_QUEUE',
          payload: { messageId: message.id, customerID }
        });
      } catch (error) {
        const updatedCustomerQueue = MessagesQueueSelectors.getContactMessagesQueue(getState(), customerID);
        const errorMessagesIds     = getMessagesIdsWithinMs(updatedCustomerQueue, message.id);

        // Reset progress when there is an error
        if (message.attachments)
          updateFileProgress({ progress: 0, customerID, dispatch, message });

        dispatch({
          type:    'UPDATE_MESSAGES_STATUS',
          payload: { messageIds: errorMessagesIds, customerID, status: 'inQueueError' }
        });
      }

      dispatch(processQueue(customerID));
    } else
      dispatch({ type: 'QUEUE_IS_NOT_RUNNING', payload: { customerID } });
  };
}

export function addMessageToQueue({ attachments, body, businessID, customer }) {
  return async function(dispatch, getState) {
    const customerID = customer.id;

    dispatch({
      type:    'ADD_MESSAGE_TO_QUEUE',
      payload: {
        attachments,
        body,
        businessID,
        customer,
        id:        `${customerID}${Date.now()}`,
        timestamp: new Date().toISOString()
      }
    });

    if (!MessagesQueueSelectors.isQueueRunning(getState(), customerID))
      dispatch(processQueue(customerID));
  };
}

export function updateMessagesStatus(messageIds, customerID, status) {
  return function(dispatch, getState) {
    dispatch({
      type:    'UPDATE_MESSAGES_STATUS',
      payload: { messageIds, customerID, status }
    });

    if (!MessagesQueueSelectors.isQueueRunning(getState(), customerID))
      dispatch(processQueue(customerID));
  };
}
